<template>
  <FlashSalesTag
    v-if="dealTag"
    :icon="dealTag.icon"
    :label="dealTag.label"
    :tooltip-text="dealTag.tooltipText"
  />
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import FlashSalesTag from './FlashSales/components/FlashSalesTag.vue'

defineProps<{
  dealTag?: {
    label: string
    icon: Component
    tooltipText?: string
  }
}>()
</script>
